import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-apps custom-scroll"
};
const _hoisted_2 = {
  class: "flex justify-between h-20"
};
const _hoisted_3 = {
  class: "scrollbar-type-nav"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "image"
};
const _hoisted_6 = {
  class: "flex items-center gap-2 mr-[20px]"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "image"
};
const _hoisted_9 = {
  class: "inner"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "info-title"
};
const _hoisted_12 = {
  class: "info-text"
};
const _hoisted_13 = {
  class: "btn"
};
import ChatAppsEditDialog from '@/components/ChatAppsEditDialog.vue';
import { computed, onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { httpGet, httpPost } from "@/utils/http";
import { checkSession } from "@/store/cache";
import { arrayContains, removeArrayItem, substr } from "@/utils/libs";
import { useRouter } from "vue-router";
import { useSharedStore } from "@/store/sharedata";
import ItemList from "@/components/ItemList.vue";
import { ChatConversationApi } from '@/api/ai/chat/conversation';
export default /*@__PURE__*/_defineComponent({
  __name: 'ChatApps',
  setup(__props) {
    const listBoxHeight = window.innerHeight - 133;
    const typeId = ref("");
    const appTypes = ref([]);
    const list = ref([]);
    const roles = ref([]);
    const store = useSharedStore();
    const showMy = ref(false);
    const userId = ref();
    const searchKey = ref("");
    const apps = computed(() => {
      return list.value.filter(item => {
        let flag = true;
        if (showMy.value) {
          flag = item.userId === userId.value;
          if (searchKey.value) {
            flag = item.name.includes(searchKey.value);
          }
        } else {
          if (searchKey.value) {
            flag = item.name.includes(searchKey.value);
          }
        }
        return flag;
      });
    });
    onMounted(() => {
      getAppType();
      getAppList();
      getRoles();
    });
    const getRoles = () => {
      checkSession().then(user => {
        roles.value = user.chat_roles;
        userId.value = user.id;
      }).catch(e => {
        console.log(e.message);
      });
    };
    const getAppType = () => {
      // httpGet("/app/type/list")
      httpGet("/ai/chat-role/type/list").then(res => {
        appTypes.value = res;
      }).catch(e => {
        ElMessage.error("获取分类失败：" + e.message);
      });
    };
    const getAppList = (tid = "") => {
      typeId.value = tid;
      // httpGet("/app/list", { tid })
      httpGet("/ai/chat-role/listPublicAndMy", {
        tid
      }).then(res => {
        const items = res;
        // 处理 hello message
        for (let i = 0; i < items.length; i++) {
          items[i].intro = substr(items[i].hello_msg, 80);
        }
        list.value = items;
      }).catch(e => {
        ElMessage.error("获取应用失败：" + e.message);
      });
    };
    const updateRole = (row, opt) => {
      checkSession().then(() => {
        const title = ref("");
        if (opt === "add") {
          title.value = "添加应用";
          const exists = arrayContains(roles.value, row.key);
          if (exists) {
            return;
          }
          roles.value.push(row.key);
        } else {
          title.value = "移除应用";
          const exists = arrayContains(roles.value, row.key);
          if (!exists) {
            return;
          }
          roles.value = removeArrayItem(roles.value, row.key);
        }
        httpPost("/app/update", {
          keys: roles.value
        }).then(() => {
          ElMessage.success({
            message: title.value + "成功！",
            duration: 1000
          });
        }).catch(e => {
          ElMessage.error(title.value + "失败：" + e.message);
        });
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    };
    const hasRole = roleKey => {
      return arrayContains(roles.value, roleKey, (v1, v2) => v1 === v2);
    };
    const router = useRouter();
    // const useRole = (role) => {
    //   router.push(`/chat?role_id=${role.id}`);
    // };
    const useRole = async role => {
      // 1. 创建对话
      const data = {
        roleId: role.id
      };
      const conversationId = await ChatConversationApi.createChatConversationMy(data);
      // 2. 跳转页面
      await router.push({
        name: 'AiChat1',
        query: {
          conversationId: conversationId
        }
      });
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const handlerAddRole = async () => {
      formRef.value.open('my-create', null, '添加角色');
    };
    /** 编辑角色 */
    const handlerCardEdit = async role => {
      formRef.value.open('my-update', role.id, '编辑角色');
    };
    /** 添加角色成功 */
    const handlerAddRoleSuccess = async e => {
      // 刷新数据
      await getAppList();
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
        class: _normalizeClass({
          active: typeId.value === ''
        }),
        onClick: _cache[0] || (_cache[0] = $event => getAppList(''))
      }, "全部分类", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appTypes.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass({
            active: typeId.value === item.id
          }),
          onClick: $event => getAppList(item.id)
        }, [item.icon ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_image, {
          src: item.icon,
          fit: "cover"
        }, null, 8, ["src"])])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.name), 1)], 10, _hoisted_4);
      }), 128))])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_checkbox, {
        modelValue: showMy.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showMy.value = $event),
        label: "我创建的",
        size: "large"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchKey.value = $event),
        size: "small",
        style: {
          "width": "240px"
        },
        placeholder: "搜索",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"])])]), _createVNode(_component_el_divider, {
        class: "!mt-[0px]"
      }), _createElementVNode("div", {
        class: "app-list-container",
        style: _normalizeStyle({
          height: listBoxHeight + 'px'
        })
      }, [_createVNode(ItemList, {
        items: apps.value,
        gap: 15,
        width: 300,
        onAdd: handlerAddRole
      }, {
        default: _withCtx(scope => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_image, {
          src: scope.item.icon,
          fit: "cover"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(scope.item.name), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(scope.item.hello_msg), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          size: "small",
          class: "sm-btn-theme",
          onClick: $event => useRole(scope.item)
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("使用")])),
          _: 2
        }, 1032, ["onClick"]), userId.value === scope.item.userId ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          size: "small",
          class: "sm-btn-theme",
          onClick: $event => handlerCardEdit(scope.item)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("编辑")])),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])])])]),
        _: 1
      }, 8, ["items"])], 4)]), _createVNode(ChatAppsEditDialog, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: handlerAddRoleSuccess
      }, null, 512)]);
    };
  }
});